<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.506 17.785l-.428-4.36V11.41h1.781v2.016l-.422 4.36h-.931zM15.148 20v-1.646h1.647V20h-1.647zm-6.53 2h14.764L16 7.236 8.618 22zm8.276-17.447l9 18A1 1 0 0 1 25 24H7a1 1 0 0 1-.894-1.447l9-18a1 1 0 0 1 1.788 0z" fill="currentColor"/>
</svg>
